import { ProductDistribution } from '../ProductDistribution/productDistribution.model';

import { ProductDistributionRoute } from '../ProductDistributionRoute/productDistributionRoute.model';

import { serializable, alias, object, list } from 'serializr';

export class ProductDistributionData {
	@serializable(
		alias('productDistributionRoute', list(object(ProductDistributionRoute)))
	)
	productDistributionRoute?: ProductDistributionRoute[] = [];

	@serializable(alias('productDistribution', object(ProductDistribution)))
	productDistribution?: ProductDistribution;
}

